import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Snackbar from 'components/DesignSystem/Snackbar';
import { CustomAlert } from 'components/AlertsCollection';
import Group from 'types/Locations/Group';
import type SavedLocation from 'types/Locations/Location';

import Row from './Row';

import './index.scss';

export interface EditSheetProps {
  open: boolean;
  dismiss: () => void;
  alert: CustomAlert | undefined;
  groups: Group[] | undefined;
  locations: SavedLocation[] | undefined;
  updateGroup: any;
  updateLocation: any;
  deleteGroup: any;
  deleteLocation: any;
}

export default function EditSheet({
  open,
  dismiss,
  alert,
  groups,
  locations,
  updateGroup,
  updateLocation,
  deleteGroup,
  deleteLocation,
}: EditSheetProps) {
  return (
    <BottomSheet open={open} dismiss={dismiss} title="Editar cadastro">
      {alert && (
        <Snackbar variant={alert.variant} className="mb-3">
          {alert.title && <div className="mb-1"><b>{alert.title}</b></div>}
          <div>{alert.message}</div>
        </Snackbar>
      )}

      <div className="edit-sheet-section">
        <span className="edit-sheet-section-title">Grupos</span>
        {groups?.map((g) => (
          <Row
            key={g.id}
            name={g.name}
            idPrefix={`group-${g.id}`}
            onEdit={(name) => updateGroup(g.id, name)}
            onDelete={() => deleteGroup(g.id)}
            confirmationBody={(
              <p>
                Tem certeza que deseja excluir o grupo
                <strong>{` ${g.name}`}</strong>
                ? Todos os locais vinculados também serão removidos.
              </p>
            )}
          />
        ))}
        {!groups?.length && <p className="edit-sheet-empty">Nenhum grupo cadastrado.</p>}
      </div>

      <div className="edit-sheet-section">
        <span className="edit-sheet-section-title">Locais</span>
        {locations?.map((l) => (
          <Row
            key={l.id}
            name={l.name}
            caption={groups?.find((g) => g.id === l.groupId)?.name}
            idPrefix={`location-${l.id}`}
            onEdit={(name) => updateLocation(l.id, name)}
            onDelete={() => deleteLocation(l.id)}
            confirmationBody={(
              <p>
                Tem certeza que deseja excluir o local
                <strong>{` ${l.name}`}</strong>
                ?
              </p>
            )}
          />
        ))}
        {!locations?.length && <p className="edit-sheet-empty">Nenhum local cadastrado.</p>}
      </div>
    </BottomSheet>
  );
}
